import { Injectable } from '@angular/core'
import { ColorCSSVarEnum } from '@shared/enums/color-css-var.enum'
import { SortDirType } from '@shared/types/sort-dir.type'

type ConvertedData = number | string | null | undefined

@Injectable({
	providedIn: 'root',
})
export class UtilsService {
	protected readonly date: DateConstructor = Date

	private _convertToNumberIfPossible(value: unknown): ConvertedData {
		if (typeof value === 'string' && !isNaN(+value)) {
			return +value
		}
		return value as ConvertedData
	}

	public sortArrayOfObjects<T>(items: T[], prop: keyof T, dir: SortDirType = 'asc'): T[] {
		return [...items].sort((a: T, b: T) => {
			const aValue: ConvertedData = this._convertToNumberIfPossible(a[prop])
			const bValue: ConvertedData = this._convertToNumberIfPossible(b[prop])

			if (aValue == null && bValue == null) return 0
			if (aValue == null) return dir === 'asc' ? -1 : 1
			if (bValue == null) return dir === 'asc' ? 1 : -1

			let comparison: number

			if (typeof aValue === 'number' && typeof bValue === 'number') {
				comparison = aValue - bValue
			} else {
				comparison = aValue.toString().localeCompare(bValue.toString())
			}

			return dir === 'asc' ? comparison : -comparison
		})
	}

	public putCursorEnd(input: HTMLInputElement): void {
		setTimeout(() => {
			const length: number = input.value.length
			input.setSelectionRange(length, length, 'forward')
		})
	}

	public inputSigns(event: KeyboardEvent): void {
		const chars: string = './юб'
		if (!chars.includes(event.key)) return

		event.preventDefault()
		const inputEl: HTMLInputElement = event.target as HTMLInputElement
		const start: number = inputEl.selectionStart ?? inputEl.value.length
		const end: number = inputEl.selectionEnd ?? start
		inputEl.setRangeText(',', start, end, 'end')
		inputEl.dispatchEvent(new Event('input', { bubbles: true }))
	}

	public getColorByCSSVar(cssVar: ColorCSSVarEnum): string {
		return getComputedStyle(document.body).getPropertyValue(cssVar)
	}

	public generateUniqId(): string {
		try {
			return crypto.randomUUID()
		} catch (error: unknown) {
			console.warn('Absent crypto', error)
			return new this.date().getTime().toString()
		}
	}
}
